import React, { useState,createContext, useContext } from "react";
//import axios from 'axios'
import request from "superagent";
import CustomSnackbars from "../Components/Lib/CustomSnackbars";
import { DataServerContext } from "./DataServerContext";

import {
  thisPost,
  thisMock,
  apiDataUrl,
  apiDataAccessUrl,
  apiUserSamNameUrl,
  apiListUrl,
  apiSaveUpdUrl
} from "../projConst";
import * as api from "../api/apiFunc";

//import { InfoWinContext } from "../infowindow/infowinContext";

export const DataServer = ({ children }) => {
  //const { alertWin, alertmessage } = useContext(InfoWinContext);
  const [loading, Setloading] = useState(false) 
  const [dataserver, SetDataServer] = useState({});
  //const [otherdata, SetOtherData] = useState({});
  
    
  const [alertmessage, SetAlertmessage] = useState(0);
  const alertTypeMess = ['success', 'warning', 'error', 'info']
  const alertWinClose = () => {
    SetAlertmessage({ open: false, mess: "", typemess: 'error'})
  };  
  
  const getServerData = (apiUrl, param, thismock, mock,RunFunc = null, showmess = null, longproc = false,longprocmess = 'Загрузка', durmess = null, action = null) => {
    //setLoading(true);
    if (longproc === true) SetAlertmessage({ open: true, mess: `${longprocmess}...`, typemess: 'success', duration: durmess })
    api.FetchLiteUrl(apiUrl, true, param , thismock, mock).then(onedata => {
      const { is_err, mess } = api.HandleFindError(onedata)
      if (is_err) 
        SetAlertmessage({ open: true, mess: mess || 'Ошибка при загрузке данных с сервера', typemess: 'error' })
      else {
        if (showmess) 
          SetAlertmessage({ open: true, mess: showmess , typemess: 'success',duration:durmess})
        SetDataServer(onedata)
      }
      if (typeof RunFunc === 'function') RunFunc(onedata,action,is_err)
      //setLoading(true);
    })
  }

  const getServerDataRedux = (apiUrl, post, param, thismock, mock, action = null, mockempty = {}, showmess = null, durmess = null) => {
    return (dispatch, getState) => {
      return api.FetchLiteUrl(apiUrl, post, param, thismock, mock,mockempty )
        .then(onedata => {
          const { is_err, mess } = api.HandleFindError(onedata)
          if (is_err) 
            SetAlertmessage({ open: true, mess: mess || ' Ошибка при загрузке данных с сервера', typemess: 'error' })
          else {
            if (showmess) 
              SetAlertmessage({ open: true, mess: showmess , typemess: 'success',duration:durmess})
          }
          return dispatch({ type: action, payload: {serverdata: onedata } })
        })
    }
  }

  const loadData = async (mockdata, url, userarg) => {
    if (thisMock) {
      return new Promise((resolve, reject) => {
        resolve(mockdata);
      });
    } else {
      if (!thisPost) {
        const { body } = await request.get(url);
        return body;
      } else {
        const { body } = await request
          .post(url)
          .set("Content-Type", "application/json")
          .send({ ...userarg });
        return body;
      }
    }
  };
 /* const getMainData = async userarg => {
    setLoading();
    //const response = loadData(mock.maindata, apiDataUrl, userarg);
    await loadData(mock.maindata, apiDataUrl, userarg).then(onedata => {
      const { is_err, mess } = api.HandleFindError(onedata);
      if (is_err) alertWin("error", mess);
      else {
        dispatch({
          type: GET_MAIN_DATA,
          payload: onedata
        });
      }
    });
  };*/

  const setLoading = (param) => Setloading(param)

  return (
    <DataServerContext.Provider
      value={{
        loading,
        Setloading,
        getServerData,
        getServerDataRedux,
        dataserver
      }}
    >
      {children}
      <CustomSnackbars 
            useropen={alertmessage.open}
            userdur={alertmessage.duration}
            userClose = {alertWinClose}
            uservar = {alertmessage.typemess}
            usermess = {alertmessage.mess}
      />
    </DataServerContext.Provider>
  );
};
